import "./Container.scss";

import React, { ComponentProps, FC, HTMLProps, Ref } from "react";

import { ClassName, OrString } from "config/types";

import classNames from "classnames";

interface IProps extends Omit<HTMLProps<HTMLDivElement>, "className"> {
  children: React.ReactNode;
  className?: ClassName;
  as?: any;
  gutters?: boolean;
  fixed?: boolean;
  maxWidth?: OrString<number>;
  ref?: Ref<HTMLDivElement>;
}

const Container: FC<IProps & ComponentProps<IProps["as"]>> = ({
  className,
  as = "div",
  gutters = false,
  fixed = false,
  maxWidth = "large",
  ref,
  ...other
}) => {
  const Component = as;

  const conditionals = {
    fixed: fixed,
    "gutters-disabled": gutters,
    [`mw-${maxWidth}`]: maxWidth,
  };
  const classes = classNames(className, conditionals, "container");
  return <Component className={classes} ref={ref} {...other} />;
};

export default Container;
